import React from 'react';
import { Typography } from 'antd';
import styled from 'styled-components';
import { CSSPixelsNumber } from '../../../../infrastructure/types/common/common-types';

const { Title: AntTitle } = Typography;

type Margin = `${number}px` | 0;

interface CustomStyles {
  marginBottom?: Margin;
  marginTop?: Margin;
  marginLeft?: Margin;
  paddingTop?: CSSPixelsNumber;
  color?: Color;
  fontWeight?: number;
}

interface TitleProps {
  level: TitleLevel;
  children: React.ReactNode;
  className?: string;
  customStyles?: CustomStyles;
}

type TitleLevel = 1 | 2 | 3 | 4 | 5;

function Title({ level, children, className, customStyles }: TitleProps): JSX.Element {
  return (
    <StyledAntTitle level={level} className={className} customstyles={customStyles}>
      {children}
    </StyledAntTitle>
  );
}

const StyledAntTitle = styled(AntTitle)<{ customstyles?: CustomStyles }>`
  &.ant-typography {
    margin-bottom: ${props => props.customstyles?.marginBottom};
    margin-top: ${props => props.customstyles?.marginTop};
    margin-left: ${props => props.customstyles?.marginLeft};
    padding-top: ${props => props.customstyles?.paddingTop};
    color: ${props => props.customstyles?.color};
    font-weight: ${props => props.customstyles?.fontWeight};
  }

  &.ant-typography + h5.ant-typography,
  &.ant-typography + h4.ant-typography,
  &.ant-typography + h3.ant-typography {
    margin-top: ${props => props.customstyles?.marginTop};
    margin-bottom: ${props => props.customstyles?.marginBottom};
    margin-left: ${props => props.customstyles?.marginLeft};
    padding-top: ${props => props.customstyles?.paddingTop};
  }
`;

export default Title;
